import { lazy } from "react";

import AppIcons from "../../../components/Base/AppIcons";
import HNavbar from "../../../components/Base/HNavbar";
import {
  dictPermissions,
  dictPermissionsGestion,
  listPermissions,
} from "./listPermissions";

const ModuloSoatLink = lazy(() => import("./views/ModuleSoatLink"));
const ModuloSoatVenta = lazy(() => import("./views/ModuleSoatVenta"));
const ModuleSoatConsultMov = lazy(() => import("./views/ModuleSoatConsultMov"));

export const SoatRefacilLink = {
  menu: "/soat-refacil",
};

export const routesSoatVentas = [
  {
    link: SoatRefacilLink.menu,
    label: <AppIcons Logo={"RECARGA_CELULAR"} name="SOAT" />,
    component: ({ subRoutes }: { subRoutes: never[] }) => (
      <HNavbar links={subRoutes} />
    ),
    permission: [...listPermissions],
    subRoutes: [
      {
        link: "/soat-refacil/modulo-soat-link",
        label: <AppIcons Logo={"RECARGA_CELULAR"} name="Envío Link SOAT" />,
        component: ModuloSoatLink,
        permission: [dictPermissions.module_soat_link],
        subRoutes: [],
      },
      {
        link: "/soat-refacil/modulo-soat-venta",
        label: <AppIcons Logo={"RECARGA_CELULAR"} name="Venta SOAT" />,
        component: ModuloSoatVenta,
        permission: [dictPermissions.module_soat_venta],
        subRoutes: [],
      },
    ],
  },
];

export const routesSoatVentasGestion = [
  {
    link: "/GestionTransaccional/soat-consult",
    label: <AppIcons Logo={"MARKETPLACE"} name="Consulta Información SOAT" />,
    component: ModuleSoatConsultMov,
    permission: [dictPermissionsGestion.module_soat_consulta_movimientos],
    subRoutes: [],
  },
];
